/**
 * How a host addresses the live workout surface.
 *
 * Only the path lives here, split out of `LiveWorkoutRoute.tsx` for the reason
 * History's `presentation.ts` gives: the route table loads the route lazily, and
 * a host that imported the path from the route's module would pull the whole
 * live surface into its own bundle to learn one string.
 *
 * The shell's Ringside action (F-NAV-08) is that host. It used to find this
 * surface as "the first `fullViewport` row in `ROUTE_TABLE`", which held only
 * for as long as `/train/live` happened to sort first; `/settings/drills` later
 * sorted ahead of it and silently repointed Ringside at the drill library. The
 * table is sorted by path for merge hygiene (§6.1), and position in it carries
 * no meaning a caller may depend on — so the surface is named, here, once.
 */

/** The route's path in `shell/routeTable.ts`. Presented, never navigated to. */
export const LIVE_ROUTE_PATH = "/train/live";
